var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 54.3,
  height: 54.3,
  viewBox: "0 0 54.3 54.3"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-error",
  "data-name": "Icon material-error",
  d: "M30.15,3A27.15,27.15,0,1,0,57.3,30.15,27.16,27.16,0,0,0,30.15,3Zm2.715,40.725h-5.43v-5.43h5.43Zm0-10.86h-5.43V16.575h5.43Z",
  transform: "translate(-3 -3)",
  fill: "#ff686e"
})));
export { SvgError as ReactComponent };
export default __webpack_public_path__ + "static/media/error.603b3b0a38a64886de40c493614dc49c.svg";